module.exports = __webpack_public_path__ + "img/20.df98aac6.png";